import "./App.css";
import React from "react";
import { ToastContainer } from "react-toastify";
import {
  LandingPage,
  LoginPage,
  SignupPage,
  EtudesPage,
  FormsPage,
  HomePage,
  EtudeDetailsPage,
  CollaboratorPage,
  DataBasePage,
  ChatPage,
  } from "./features";
import Navigation from "./components/ui/navigation/navigation";
import { Routes, Route, useLocation } from "react-router-dom";

function App() {
  const location = useLocation();

  // define paths that should NOT use Navigation
  const noNavPaths = ["/", "/login", "/registration", "/home"];
  const hideNav = noNavPaths.includes(location.pathname);

  return (
    <>
      {hideNav ? (
        // Pages without Navigation
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/registration" element={<SignupPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/home" element={<HomePage />} />
        </Routes>
      ) : (
        // Pages with Navigation
        <Navigation>
          <Routes>
            <Route path="/etudes" element={<EtudesPage />} />
            <Route
              path="/etudes-Details/:studyId"
              element={<EtudeDetailsPage />}
            />
            <Route path="/formulaires" element={<FormsPage />} />
            <Route path="/collaborateurs" element={<CollaboratorPage />} />
            <Route path="/bases-de-donnees" element={<DataBasePage />} />
            <Route path="/messagerie" element={<ChatPage />} />
         </Routes>
        </Navigation>
      )}
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="light" 
        icon={false}  
        progressClassName="toast-progress"
        toastClassName="custom-toast"
        bodyClassName="toast-body"
      />
    </>
  );
}

export default App;
